import { useContext } from "react";
import { CartContext } from '../../contexts/CartContext';
import { useEffect, useState } from "react";
import { getDomainRegisterFormPageData } from '../../api/user/domain_register_form_page.js'
import { DISPLAY_LANG } from "../../config";
import { onlyLatinMessage } from "../../api/user/register-page";
import Loading from "../../components/loading";
import PhoneInput from "react-phone-input-2";
import Select from "react-select";
import countryList from "country-list";
import axios from "../../axios";
import "react-phone-input-2/lib/style.css";
import "../../stylesheets/user/domain-register-details.css";
import { useNavigate } from "react-router-dom";

export default function DomainRegisterDetails() {
  const [isLoading, setIsLoading] = useState(true);
  const [pageData, setPageData] = useState(null);
  const [formData, setFormData] = useState([]);
  const { orders, payHostingsFromCart } = useContext(CartContext);
  const [showLoadingSpiner, setShowLoadingSpiner] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const loadingData = async () => {
      try {
        const data = await getDomainRegisterFormPageData();
        setPageData(data);
      } catch (error) {
        console.log(error);
      }
    };

    loadingData();
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (orders.length) {
      setIsLoading(true);

      setFormData(
        orders
          .map((order) => ({
            orderId: order.id,
            domainName: order.domain,
            item_type: order.item_type,
            person_r: '',
            name: "",
            passport: "",
            passport_date_of_issue: "",
            birth_date: "",
            company: "",
            email: "",
            address: "",
            city: "",
            country: "",
            zipcode: "",
            phone_cc: "",
            phone: "",
            user_id: localStorage.getItem("user_id"),
            plan: order.domain_connected_hosting_name,
            billing_type: order.domain_connected_hosting_billing_type,
            customer_id: localStorage.getItem("reseller_customer_id"),
          }))
          .filter(order => order.item_type === 'domain')
      )

      setIsLoading(false);
    }
  }, [orders]);

  const countryOptions = countryList.getData().map((c) => ({
    value: c.code,
    label: c.name,
    flagUrl: `https://flagcdn.com/24x18/${c.code.toLowerCase()}.png`,
  }));

  const onChangeInput = (index, e) => {
    const nonLatinLetters = /[^\p{Script=Latin}\d\s~!@#$%^&*()_+=\-`[\]{}|\\:;"'<>,.?/]/u;

    if (nonLatinLetters.test(e.target.value)) {
      return alert(onlyLatinMessage[DISPLAY_LANG]);
    }

    const { name, value } = e.target;

    let filteredValue = value;

    if (["name", "city", "company"].includes(name)) {
      filteredValue = value.replace(/[^a-zA-Z\s]/g, "");
    }

    else if (name === "address") {
      filteredValue = value.replace(/[^a-zA-Z0-9\s,.\-#/]/g, "");
    }

    else if (name === "zipcode") {
      filteredValue = value.replace(/[^a-zA-Z0-9\s\-]/g, "");
    }

    else if (name === "email") {
      filteredValue = value;
    }
    else if (name === "passport") {
      filteredValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
    }

    const updatedData = [...formData];
    updatedData[index] = {
      ...updatedData[index],
      [name]: filteredValue,
    };

    setFormData(updatedData);
  };

  const validateSingle = (data) => {
    if (!data.name?.trim()) return false;
    if (!data.company?.trim()) return false;
    if (!data.email?.trim()) return false;
    if (!data.address?.trim()) return false;
    if (!data.city?.trim()) return false;
    if (!data.country?.trim()) return false;
    if (!data.zipcode?.trim()) return false;
    if (!data.phone_cc) return false;
    if (!data.phone?.trim()) return false;

    const numericPhone = data.phone.replace(/\D/g, "");
    const phonePattern = /^[0-9]{6,14}$/;

    if (!phonePattern.test(numericPhone)) return false;

    return true;
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (showLoadingSpiner) return;

    /**
     * @description 
     * form vaildacia
    */

    for (let i = 0; i < formData.length; i++) {
      const isValid = validateSingle(formData[i]);
      if (!isValid) {
        alert(`${orders[i].domain} — ${pageData.alert_message_error}`);
        return;
      }
    }

    setShowLoadingSpiner(true);

    /**
     * @description 
     * post enq anum enq contakti tvyalneri registraciayi hamar
     * ayn petqa a ashxati VCHARUMIC ARAJ 
    */

    let resultsContacts = [];

    for (const elem of formData) {
      if (elem.item_type === 'domain' && elem.domainName.endsWith('.ru')) {
        let finalData = {
          ...elem,
          passport: `${elem.passport}, issued by Moscow Police, ${elem.passport_date_of_issue}`,
        }

        try {
          const resContactRu = await axios.post('contact/domain/add_ru_contact', finalData);

          if (!resContactRu.data.ok) {
            throw new Error('Request failed');
          }

          const newData = { ...elem, reg_contact_id: resContactRu.data.contact_id };
          resultsContacts.push(newData);
          setShowLoadingSpiner(false);
        } catch (error) {
          alert(error.response.data.domain_name + ' - ' + error.response.data.error.message);
          setShowLoadingSpiner(false);
          return;
        }
      } else {
        try {
          const resContact = await axios.post('contact/domain/add_contact', elem);

          if (!resContact.data.ok) {
            throw new Error('Request failed');
          }

          const data = resContact.data.default_contacts.Contact ?? {};

          const newData = {
            ...elem,
            reg_contact_id: resContact.data.contact_id,
            admin_contact_id: data.admin ?? -1,
            tech_contact_id: data.tech ?? -1,
            billing_contact_id: data.billing ?? -1,
          };

          resultsContacts.push(newData);
          setShowLoadingSpiner(false);
        } catch (error) {
          console.log(error.response.data);
          alert(error.response.data.domain_name + ' - ' + error.response.data.error.message);
          setShowLoadingSpiner(false);
          return;
        }
      }
    }

    localStorage.setItem('domain_registration_contacts', JSON.stringify(resultsContacts));

    setShowLoadingSpiner(false);
    navigate('/user/payment-method');
  };

  if (isLoading || !pageData) return <Loading />;

  return (
    <div className="connect_page wrapper">
      <div className="container">
        <h1 className="title">{pageData.title}</h1>

        <form onSubmit={onSubmit}>

          {formData.map((elem, index) => (
            <div className="box" key={index}>
              <h2>{elem.domainName}</h2>

              <div className="form-groups">
                <div className="form_group">
                  <label>
                    {pageData.full_name_label} <span>*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData[index]?.name}
                    onChange={(e) => onChangeInput(index, e)}
                  />
                </div>

                {elem.item_type === 'domain' && elem.domainName.endsWith('.ru') && (
                  <div className="form_group">
                    <label>
                      {pageData.passport_label} <span>*</span>
                    </label>
                    <input
                      type="text"
                      name="passport"
                      value={formData[index]?.passport}
                      onChange={(e) => onChangeInput(index, e)}
                    />
                  </div>
                )}

                {elem.item_type === 'domain' && elem.domainName.endsWith('.ru') && (
                  <div className="form_group">
                    <label>
                      {pageData.passport_date_of_issue} <span>*</span>
                    </label>
                    <input
                      type="date"
                      name="passport_date_of_issue"
                      value={formData[index]?.passport_date_of_issue}
                      onChange={(e) => onChangeInput(index, e)}
                    />
                  </div>
                )}

                {elem.item_type === 'domain' && elem.domainName.endsWith('.ru') && (
                  <div className="form_group">
                    <label>
                      {pageData.person_r_label} <span>*</span>
                    </label>
                    <input
                      type="text"
                      name="person_r"
                      value={formData[index]?.person_r}
                      onChange={(e) => onChangeInput(index, e)}
                    />
                  </div>
                )}

                {elem.item_type === 'domain' && elem.domainName.endsWith('.ru') && (
                  <div className="form_group">
                    <label>
                      {pageData.birth_label} <span>*</span>
                    </label>
                    <input
                      type="date"
                      name="birth_date"
                      value={formData[index]?.birth_date.split('.').reverse().join('-')}
                      onChange={(e) => {
                        const value = e.target.value;
                        const res = value.split('-').reverse().join('.');
                        onChangeInput(index, { target: { name: 'birth_date', value: res } })
                      }}
                    />
                  </div>
                )}

                <div className="form_group">
                  <label>
                    {pageData.company_label} <span>*</span>
                  </label>
                  <input
                    type="text"
                    name="company"
                    value={formData[index]?.company}
                    onChange={(e) => onChangeInput(index, e)}
                  />
                </div>

                <div className="form_group">
                  <label>
                    {pageData.email_label} <span>*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData[index]?.email}
                    onChange={(e) => onChangeInput(index, e)}
                  />
                </div>

                <div className="form_group half">
                  <label>
                    {pageData.phone_label} <span>*</span>
                  </label>
                  <PhoneInput
                    preferredCountries={["am", "ru", "ge", "us", "fr"]}
                    value={
                      (formData[index]?.phone_cc || "") +
                      (formData[index]?.phone || "")
                    }
                    onChange={(value, data) => {
                      const updatedData = [...formData];
                      updatedData[index] = {
                        ...updatedData[index],
                        phone: value.replace(data.dialCode, ""),
                        phone_cc: data.dialCode,
                      };
                      setFormData(updatedData);
                    }}
                    inputStyle={{
                      width: "100%",
                      fontSize: "14px",
                      padding: "19px 19px 18.4px 50px",
                    }}
                    buttonStyle={{ borderRadius: "6px 0 0 6px" }}
                    inputProps={{ name: "phone", type: "tel" }}
                  />
                </div>

                <div className="form_group half">
                  <label>
                    {pageData.zipcode} <span>*</span>
                  </label>
                  <input
                    type="text"
                    name="zipcode"
                    value={formData[index]?.zipcode}
                    onChange={(e) => onChangeInput(index, e)}
                  />
                </div>

                <div className="form_group half">
                  <label>
                    {pageData.country_label} <span>*</span>
                  </label>

                  <Select
                    name="country"
                    options={countryOptions}
                    value={
                      formData[index]?.country
                        ? countryOptions.find(
                          (c) => c.value === formData[index].country
                        )
                        : null
                    }
                    onChange={(selectedOption) => {
                      const updatedData = [...formData];
                      updatedData[index] = {
                        ...updatedData[index],
                        country: selectedOption.value,
                      };
                      setFormData(updatedData);
                    }}

                    placeholder={pageData.select_country}

                    formatOptionLabel={(option) => (
                      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <img
                          src={option.flagUrl}
                          alt={option.label}
                          style={{ width: "20px", height: "14px" }}
                        />
                        <span>{option.label}</span>
                      </div>
                    )}

                    styles={{
                      control: (provided) => ({
                        ...provided,
                        fontSize: "16px",
                        borderRadius: "6px",
                        paddingLeft: "0",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        fontSize: "15px",
                      }),
                      placeholder: (provided) => ({
                        ...provided,
                        fontSize: "14px",
                      }),
                      indicatorSeparator: () => ({ display: "none" }),
                      menu: (provided) => ({ ...provided, overflowX: "hidden" }),
                      option: (provided, state) => ({
                        ...provided,
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        padding: "10px",
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#000",
                        backgroundColor: state.isFocused ? "#f0f0f0" : "#fff",
                      }),
                    }}
                  />
                </div>

                <div className="form_group half">
                  <label>
                    {pageData.city_label} <span>*</span>
                  </label>
                  <input
                    type="text"
                    name="city"
                    value={formData[index]?.city}
                    onChange={(e) => onChangeInput(index, e)}
                  />
                </div>

                <div className="form_group">
                  <label>
                    {pageData.address_label} <span>*</span>
                  </label>
                  <input
                    type="text"
                    name="address"
                    value={formData[index]?.address}
                    onChange={(e) => onChangeInput(index, e)}
                  />
                </div>
              </div>
            </div>
          ))}

          <button type="submit" className="btn flex-center">
            {pageData.btn_text} {showLoadingSpiner && <span className="spinner"></span>}
          </button>

        </form>
      </div>
    </div>
  );
}
